import { render, staticRenderFns } from "./products.page.vue?vue&type=template&id=49983ea1&scoped=true"
import script from "./products.page.vue?vue&type=script&lang=ts"
export * from "./products.page.vue?vue&type=script&lang=ts"
import style0 from "./products.page.vue?vue&type=style&index=0&id=49983ea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49983ea1",
  null
  
)

export default component.exports